import SBPLogo from './SBPLogo';

export default SBPLogo;
